import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import { trackValues, setCid } from '../tracker';


const LRPixel = () => {
  let instanceKey = '';
  const profile = useSelector(state => state.profile.data && state.profile.data.user);
  const userId = profile && profile.id;

  useEffect(() => {
    instanceKey = localStorage.getItem('_x1');
    if (!instanceKey) {
      instanceKey = uuidv4();
      localStorage.setItem('_x1', instanceKey);
    }
    setCid(userId);
    trackValues('_x1', true, {
      context: { _x1: instanceKey, cid: userId },
    });
  }, [userId]);

  return true;
};

export default LRPixel;



// WEBPACK FOOTER //
// ./src/components/LRPixel.js